module.exports = __webpack_public_path__ + "img/anita-kecil.038c0eeb.png";